<template>
    <div style="width: 100%;height:100%;position:relative;display:flex;align-items:center;justify-content:center;background:#000">
        <!-- <div :class="isfull === 0 ? 'notFullTitle' : 'fullTitle' " class="text">{{videoList.videoName}}</div> -->
        <div :class="isfull === 0 ? 'notFull' : 'full' " class="text" @click="full">{{text}}</div>
        <iframe :class="isfull === 0 ? 'small' : 'big' " frameborder="0"
            :src="'http://local.vrmaker.vip:38080/webrtc/index.html?' + videoList.videoCode">
        </iframe>
    </div>

</template>

<script>
    export default {
        name: "Video",
        props: ["videoList"],
        data() {
            return {
                isfull: 0,
                text: '全屏'
            }
        },
        methods: {
            full() {
                this.isfull === 0 ? this.isfull = 1 : this.isfull = 0
                this.text === '全屏' ? this.text = '取消全屏' : this.text = '全屏'
            }
        }
    }
</script>

<style lang="less" scoped>
    .small {
        width: ((5480/108)*16)/9vh;
        .h(548);
    }

    .big {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
    }

    .text {
        color: white;
        font-size: 20rem;
        z-index: 101;
    }

    .notFullTitle {
        position: absolute;
        left: 25px;
        top: 25px;
    }

    .fullTitle {
        position: fixed;
        left: 25px;
        top: 25px;
    }

    .notFull {
        position: absolute;
        right: 25px;
        bottom: 25px;
        cursor: pointer;
    }

    .full {
        position: fixed;
        right: 25px;
        bottom: 25px;
        cursor: pointer;
    }
</style>